import apiWrapper from '@/helpers/apiWrapper';
import type {
  IWinnerGetParams, IWinnerFilterGetResponse, IWinnerGetResponse, IWinnerFilterGetParams,
} from '@/types/top';

export default {
  get: (params: IWinnerGetParams) => apiWrapper.get<IWinnerGetResponse>('/api/v1/winners', { params }),
  getFilter: (params?: IWinnerFilterGetParams) => apiWrapper.get<IWinnerFilterGetResponse>('/api/v1/winners/filter', { params }),
};
